import React, { useState } from 'react'
import Navbar from './Navbar'
import CountryCode from "../data/CountryCode"
import Swal from 'sweetalert2';
import axios from 'axios'
import { Link } from 'react-router-dom'
import {
  ArrowRight,
  CalendarCheck,
  Clock3,
  Mail,
  Phone,
  ShieldCheck,
  Sparkles,
  UsersRound
} from 'lucide-react'
import BottomContent from './BottomContent'
import DarkModeButton from './DarkModeButton.js'
import Thank from './Thank.js'
import ScrollButton from './ScrollButton.js'
import ContactButton from './ContactButton.js'
import './ScheduleDemo.css'


export default function ScheduleDemo() {

  const [firstname, setFirstName] = useState('');
  const [lastname, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [countrycode, setCountryCode] = useState('');
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState(false);

  const handleSendData = () => {

    if (email.length === 0 || mobile.length === 0) {
      setError(true)
    } else {

      const url = "https://vedalytics.com/scheduleData.php"
      let fData = new FormData();
      fData.append('firstname', firstname);
      fData.append('lastname', lastname);
      fData.append('email', email);
      fData.append('company', company);
      fData.append('countrycode', countrycode);
      fData.append('mobile', mobile);

      // axios.post(url, fData)
      //   .then(response => alert("Your form has been submitted successfully!"))
      //   .catch(error => alert("Something went wrong!"));

      // setFirstName('');
      // setLastName('');
      // setEmail('');
      // setCompany('');
      // setCountryCode('');
      // setMobile('');
      axios.post(url, fData)
      .then(response => {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Your form has been submitted successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        // Clear the form after submission
      setFirstName('');
      setLastName('');
      setEmail('');
      setCompany('');
      setCountryCode('');
      setMobile('');
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      });
    }
  }

  const demoHighlights = [
    { icon: <CalendarCheck size={22} />, title: 'Tailored walkthrough', text: 'See the Vedalytics approach mapped around your team, data, and business goals.' },
    { icon: <UsersRound size={22} />, title: 'Expert conversation', text: 'Talk with solution specialists who understand enterprise delivery and AI adoption.' },
    { icon: <ShieldCheck size={22} />, title: 'Clear next steps', text: 'Leave with practical recommendations, timelines, and the right engagement model.' }
  ]

  return (
    <>
      <Navbar />

      <main className="schedule-page">
        <section className="schedule-hero">
          <div className="schedule-hero-bg" aria-hidden="true"></div>
          <div className="container schedule-hero-inner">
            <div className="schedule-copy">
              <span className="schedule-eyebrow"><Sparkles size={16} /> Vedalytics consultation</span>
              <h1>Talk to Vedalytics experts and plan your next intelligent solution.</h1>
              <p>
                Book a focused conversation with our team to explore AI products, digital transformation,
                automation, analytics, and managed technology models for your organization.
              </p>

              <div className="schedule-proof-grid">
                <div>
                  <strong>30 min</strong>
                  <span>Discovery call</span>
                </div>
                <div>
                  <strong>3 steps</strong>
                  <span>Assess, align, roadmap</span>
                </div>
                <div>
                  <strong>1:1</strong>
                  <span>Specialist guidance</span>
                </div>
              </div>
            </div>

            <aside className="schedule-form-panel" aria-label="Schedule demo form">
              <div className="schedule-form-header">
                <div className="schedule-form-icon">
                  <CalendarCheck size={28} />
                </div>
                <div>
                  <span>Schedule a demo</span>
                  <h2>Start the conversation</h2>
                </div>
              </div>

              <div className="schedule-form-grid">
                <div className="schedule-field">
                  <label htmlFor="firstname">First Name</label>
                  <input id="firstname" type="text" value={firstname} onChange={(e) => setFirstName(e.target.value)} placeholder="Enter first name" />
                </div>
                <div className="schedule-field">
                  <label htmlFor="lastname">Last Name</label>
                  <input id="lastname" type="text" value={lastname} onChange={(e) => setLastName(e.target.value)} placeholder="Enter last name" />
                </div>
              </div>

              <div className="schedule-field">
                <label htmlFor="email">Email Id <span>*</span></label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required />
                {error && email.length <= 0 ? <small>Email id required</small> : ''}
              </div>

              <div className="schedule-field">
                <label htmlFor="company">Company</label>
                <input id="company" type="text" value={company} onChange={(e) => setCompany(e.target.value)} placeholder="Company name" />
              </div>

              <div className="schedule-field">
                <label htmlFor="countrycode">Country & Code</label>
                <select name="countrycode" id="countrycode" value={countrycode} onChange={(e) => setCountryCode(e.target.value)}>
                  <option value="" disabled>Select country</option>
                  {
                    CountryCode.map((country, i) => {
                      return <option key={i}>{country.name} ({country.dial_code})</option>
                    })
                  }
                </select>
              </div>

              <div className="schedule-field">
                <label htmlFor="number">Mobile Number <span>*</span></label>
                <input id="number" type="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Enter mobile number" required />
                {error && mobile.length <= 0 ? <small>Mobile number required</small> : ''}
              </div>

              <p className="schedule-privacy">
                By submitting your information, you agree to the terms listed on our Privacy Policy.
                <b> Vedalytics</b> will only use this information to contact you about requested products and services.
              </p>

              <div className="schedule-actions">
                <button onClick={handleSendData} className="schedule-submit-btn">
                  Send Request <ArrowRight size={18} />
                </button>
                <Link to="/" className="schedule-home-link">Back to Home</Link>
              </div>
            </aside>
          </div>
        </section>

        <section className="schedule-info-section">
          <div className="container">
            <div className="schedule-section-heading">
              <span>What you can expect</span>
              <h2>A polished demo built around your priorities.</h2>
            </div>
            <div className="schedule-highlight-grid">
              {demoHighlights.map((item) => (
                <article className="schedule-highlight-card" key={item.title}>
                  <div className="schedule-highlight-icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="schedule-contact-strip">
          <div className="container schedule-contact-inner">
            <div>
              <span>Prefer direct contact?</span>
              <h2>Our team is ready to help.</h2>
            </div>
            <div className="schedule-contact-list">
              <a href="mailto:info@vedalytics.com"><Mail size={18} /> info@vedalytics.com</a>
              <a href="tel:+17252959168"><Phone size={18} /> +1 (725) 295-9168</a>
              <span><Clock3 size={18} /> Response within one business day</span>
            </div>
          </div>
        </section>
      </main>

      <Thank />
      <DarkModeButton />
      <BottomContent />
      <ContactButton />
      <ScrollButton />
    </>
  )
}
